import { ADD_MAP_MARKERS_TO_CACHE } from '../constants/index'
import { convertPropertiesJSONToRecord } from 'utils'
export function addMapMarkersToCache(json, isFranchise, loc) {
  const properties = convertPropertiesJSONToRecord(json, isFranchise, loc)
  return {
    type: ADD_MAP_MARKERS_TO_CACHE,
    data: properties,
  }
}



// WEBPACK FOOTER //
// ./src/actions/addMapMarkersToCache.js